import { siteData } from "../data/intelligence";

export function RiskAlerts() { const afx = siteData.projects.find((item) => item.hardStop)!; return <section><h2>风险警报</h2><div className="alert alert-danger"><strong>⛔ {afx.name}：停止参与</strong><span>{afx.conclusion} 低风险不代表无风险。</span></div></section>; }
